export default __webpack_public_path__ + "static/media/AirportFuelRestrictionStyles.b2036400.bin";